// 系统修改记录（按版本倒序）
export const CHANGELOG = [
  {
    version: '预览版',
    date: '2025-11-11',
    changes: [
      '结果标签补充：新增 baseImpedanceMode/lineImpedanceSecondary/voltageLow/k0/restraintCurrent',
      '导出值优化：formatResultValueExport 语义映射 baseImpedanceMode 与 voltageLow',
      '公式说明增强：方向保护补充相量判据极化角范围与典型建议',
      '文档与记录：继保计算.md 与 CHANGELOG.md 增补本次修改摘要',
    ],
  },
  {
    version: '预览版',
    date: '2025-11-07',
    changes: [
      '公式文案统一：If.min 显示为“最小故障电流（二次）: If.min = min(If) / nCT”；解释为“最小一次故障电流 / CT变比”',
      'i18n 更新：更新 export.report.formulas.common.if_min 与 if_min_explain 的中英文文案',
      '评估项国际化：各保护类型的 If.min 在“计算公式与计算过程”中使用 i18n 引用，并移除 text 中括号解释避免重复',
      '重复括号修复：处理 CalculationPage 组合渲染导致的括号重复问题，预览验证通过',
      '术语澄清：区分“二次故障电流（侧别换算）”与“最小故障电流（二次）（最不利工况）”',
    ],
  },
  {
    version: '预览版',
    date: '2025-11-05',
    changes: [
      '表单联动修复：CalculationPage 将 Form.useWatch 迁移到表单内部（SCWatcher），消除跨上下文警告并保持联动逻辑',
      '文档对齐：README 增补设备库导入/叠加颜色与自动联动说明；DEVELOPMENT 增补脚本与端口、测试日志开关',
      '测试修复：增加 Node 测试环境 localStorage polyfill，修复 shareUtils 测试失败；全部测试通过',
      '分享态增强：打包叠加视图状态与有效期；ShareView 解码只读预览、到期校验与一次性 Token 提示',
      '导出优化：exportUtils 按需动态加载 html2canvas 与 jsPDF，降低主包体积',
      '距离保护 R/X/θ 精细渲染：坐标轴箭头与网格、线路角虚线、分区边界线与裕度圈、标签完善',
      '导出兼容增强：Markdown 支持 Z 平面与 Id–Ir 专节与图像嵌入；PDF/PNG 导出与多坐标系一致',
      '文档更新：CORE_IMPROVEMENTS 与 DEVELOPMENT 增补精细渲染与导出兼容说明',
      '开发与预览：端口冲突自动切换；本地预览 http://localhost:3002/ 验证通过',
      '厂商导入增强：新增“统一颜色”开关与拾色器，预览颜色列',
      '解析透传：支持 JSON/CSV 颜色与二次谐波闭锁系数 Kb 透传',
      '叠加颜色优先级：优先使用记录颜色（meta.color/results.color），回退 colorMap/调色板',
      '差动 Id–Ir 渲染增强：基础定值与各段阈值终点圆点标记',
      '计算修复：距离保护 reach 字段改为人类可读字符串（如“85%线路长度”），与单元测试期望一致',
      '曲线知识助手：设置新增 AI 模型参数与“问问 AI”面板；外部不可用时回退本地选择性校核生成分析（buildSelectivityMatrix/analyzeSelectivity）；新增 i18n 文案与预览验证 http://localhost:4173/',
    ],
  },
  {
    version: '1.0.0',
    date: '2025-10-15',
    changes: [
      '初始版本：计算、历史、知识库、分享视图等基础功能',
    ],
  },
];

export default CHANGELOG;